import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const TrademarkRegistration = () => {
  const usps = [
    {
      title: 'Expert Legal Guidance',
      description: 'Our USPTO-registered attorneys bring decades of experience in trademark law. We provide strategic advice, handle complex filings, and ensure your application meets every legal requirement for swift approval.'
    },
    {
      title: 'Comprehensive Search & Analysis',
      description: 'Avoid costly conflicts with our thorough trademark searches across federal, state, and common law databases. We identify potential issues early and provide clear guidance on your mark\'s registrability.'
    },
    {
      title: 'Fast & Affordable Service',
      description: 'Professional trademark registration starting at just $45—no hidden fees, no surprises. Our streamlined process delivers quick turnaround times while maintaining the highest standards of quality.'
    },
    {
      title: 'End-to-End Support',
      description: 'From initial consultation through registration and renewal, we\'re with you every step. We monitor applications, respond to USPTO office actions, and provide lifetime renewal reminders.'
    }
  ];

  const whyChooseContent = {
    about: 'Trademark registration is the cornerstone of brand protection in the United States. It provides exclusive legal rights to use your brand name, logo, or slogan in commerce, preventing others from using confusingly similar marks. A registered trademark enhances your business credibility, increases brand value, and provides nationwide protection.',
    intro: 'With over 10,000 successful registrations and a 98% approval rate, Trademark Vector is America\'s trusted choice for trademark protection.',
    paragraph1: 'Our team of USPTO-registered attorneys doesn\'t just process paperwork—we provide strategic guidance that maximizes your brand\'s protection. Every application receives comprehensive trademark searches, legal analysis, and personalized consultation to ensure the best possible outcome.',
    paragraph2: 'Whether you\'re a startup launching your first brand or an established company expanding your portfolio, we deliver the same exceptional service. Transparent pricing, expert guidance, and unwavering commitment to your success—that\'s the Trademark Vector difference.'
  };

  return (
    <ServiceTemplate
      title="Trademark Registration"
      subtitle="Secure Your Brand Identity with Professional Trademark Services"
      description="Protect your business name, logo, and brand with comprehensive trademark registration. Starting at just $45, our expert legal team handles everything from search to filing, ensuring your brand is legally protected nationwide."
      heroImage="https://images.pexels.com/photos/2042606/pexels-photo-2042606.jpeg"
      aboutImage="https://images.unsplash.com/photo-1562564055-71e051d33c19?w=800"
      serviceId="trademark-registration"
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default TrademarkRegistration;
